import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Collapse,
  Typography,
  styled,
} from "@mui/material";
import moment from "moment";
import React, { memo, useEffect, useMemo, useState } from "react";
import useTimer from "../../../customHooks/useTimer";
import OrderDetails from "./OrderDetails";

const OrderHeader = styled(Box)(({ theme }) => ({
  color: "#111",
  // color: "rgb(255, 255, 255)",
  // mixBlendMode: "difference",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  "& span": {
    fontSize: "18px",
    fontWeight: "500",
    letterSpacing: "2px",
  },
}));

const DetailsDiv = styled(AccordionDetails)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "#111",
    // color: "rgb(255, 255, 255)",
    // mixBlendMode: "difference",

    fontSize: "12px",
    lineHeight: "1.4",
  },
}));

const OrderCard = ({
  order,
  handlePickupOrder,
  handleUnpickOrder,
  handleViewHistoryDetails,
  handlePrint,
  handleMarkPick,
  handleResendInvoice,
  fulfilled,
  fulfill,
  markPick,
  print,
}) => {
  const AccDiv = styled(Accordion)(({ theme }) => ({
    //background: fulfilled ? "#e6ffe6" : lightColor,
    background: print ? ((order.order_info?.orderSequence === 1)
      ? "#E6E6FA"
      : (order.order_info?.orderSequence === 2)
        ? "#FC8EAC"
        : (order.order_info?.orderSequence === 3)
          ? "#FFD580"
          : (order.order_info?.orderSequence === 4)
            ? "#ffcccb" : "#ff9693") : ((order.orderSequence === 1)
              ? "#E6E6FA"
              : (order.orderSequence === 2)
                ? "#FC8EAC"
                : (order.orderSequence === 3)
                  ? "#FFD580"
                  : (order.orderSequence === 4)
                    ? "#ffcccb" : "#ff9693"),
    transition: "0.3s",
    // width:"440px",
    "& h3": {
      margin: "0",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      top: "24px",
      right: "10px",
      position: "absolute",
    },

    "& span": {
      fontSize: "15px",
      color: "#111",
    },
    "& button": {
      textTransform: "none",
    },
    "& svg": {
      color: "#111",
      // color: "rgb(255, 255, 255)",
      // mixBlendMode: "difference",
    },
  }));
  //console.log("order", order);
  const [open, setOpen] = useState(true);

  const TimerHook = useMemo(() => useTimer, [order?.created_at]);
  const { currentTimer, lightColor } = TimerHook(order?.created_at);

  // console.log('lightColor',lightColor)

  const handlePick = () => {
    handlePickupOrder(order);
  };

  return (
    <AccDiv expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box>
          <OrderHeader>
            <h3>Order: #{print ? order.order_info?.salesid : order.salesid}</h3>
            <span style={{ marginRight: "30px" }}>{currentTimer}</span>
          </OrderHeader>

          <Box
            display={"grid"}
            gridTemplateColumns={"auto"}
            gap="15px"
            mt={3}
            color={"#999"}
          >
            <span>
              School:{" "}
              {print ? order.order_info?.school_info?.SchoolName : order.school_info?.SchoolName}
            </span>
          </Box>

          <Box
            display={"grid"}
            gridTemplateColumns={"1.75fr 1fr"}
            gap="15px"
            mt={3}
            color={"#999"}
          >
            <span>
              Order date:{" "}
              {moment(order.created_at).format("ddd, MMM Do YYYY, h:mm a")}
            </span>
            <span>Client : {print ? order.order_info?.customer.name : order.customer.name}</span>
          </Box>
        </Box>
      </AccordionSummary>

      <OrderDetails
        fulfilled={fulfilled}
        fulfill={fulfill}
        order={order}
        markPick={markPick}
        handleMarkPick={handleMarkPick}
        handleViewHistoryDetails={handleViewHistoryDetails}
        handlePrint={handlePrint}
        handlePickupOrder={handlePickupOrder}
        handleUnpickOrder={handleUnpickOrder}
        handleResendInvoice={handleResendInvoice}
        print={print}

      />
    </AccDiv>
  );
};

export default OrderCard;
